<template>
  <div id="app">
    <Banner />
    <Export_document />
  </div>
</template>

<script>
import Export_document from "./views/Export_document.vue";
import Banner from "./views/Banner.vue";

export default {
  name: "App",
  components: {
    Banner,
    Export_document,
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Rubik&display=swap");
// @import url("https://fonts.googleapis.com/css2?family=Poppins&display=swap");

@import "./assets/css/modal.css";
@import "./assets/css/tooltip.css";

body,
#app {
  background-color: #f5f6f8;
  width: 100%;
  margin: 0px;
  font-family: "Rubik";
}

/* GLOBAL CCS */
.white {
  color: #ffffff !important;
}

.green {
  color: #369e3b !important;
}

.blue {
  color: #003b51 !important;
}

.darkBlue {
  color: #192a3e !important;
}

.mauto {
  margin: auto;
}

.mt20 {
  margin-top: 20px;
}

.mt30 {
  margin-top: 30px;
}

.mb40 {
  margin-bottom: 40px;
}

.mr10 {
  margin-right: 10px;
}

.pd5 {
  padding: 5px;
}

.pf10 {
  padding-left: 10px;
}

.pd20H {
  padding: 0px 20px;
}

.pd10Top {
  padding-top: 10px;
}

.pd3Left {
  padding-left: 3px;
}

.radius5 {
  border-radius: 5px;
}

.w175 {
  width: 176px;
}

.h30 {
  height: 30px;
}

.bgWhite {
  background-color: #fdfdfd;
}

.bgGrey {
  background-color: #dde3e7;
}
.bgGreen {
  background-color: #369e3b;
}
.bgBlue {
  background-color: #003b51;
}
.bgLightGrey {
  background-color: #003b5175;
}

span {
  font-size: 12px;
  line-height: 16px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.01em;
}

.fw600 {
  font-weight: 600;
}
</style>
